import { Component, Input, OnChanges } from '@angular/core';
import { ReportColumn } from '../../shared/data-table/data-table.component';
import {
  aggregateTimelineStatus,
  driverDigestSegments,
  driverDigestStatItems,
  topDriversByHours
} from '../../utils/chart-helpers';
import { CHART_COLORS } from '../../utils/chart-theme';
import {
  driverDisplayName,
  driverProfileImage,
  formatHours,
  millisToHours,
  timelineStatusBadge,
  timelineStatusLabel
} from '../../utils/kpi-helpers';

function formatDateTime(value: any): string {
  if (!value) return '—';
  return new Date(value).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
}

@Component({
  selector: 'app-br-driver-digest-tab',
  templateUrl: './driver-digest-tab.component.html'
})
export class BrDriverDigestTabComponent implements OnChanges {
  @Input() loading: boolean;
  @Input() error: string;
  @Input() data: any;

  readonly secondaryColor = CHART_COLORS[1];

  statusSegments: any[] = [];
  digestStatItems: any[] = [];
  timelineStatusItems: any[] = [];
  hoursByDriver: any[] = [];
  noTimesheetItems: any[] = [];
  timelines: any[] = [];
  driversWithoutTimeline: any[] = [];

  timelineColumns: ReportColumn[] = [];
  missingTimelineColumns: ReportColumn[] = [
    {
      key: 'driver',
      header: 'Driver',
      type: 'avatar',
      avatarName: (row) => driverDisplayName(row),
      avatarImage: (row) => driverProfileImage(row),
      avatarVariant: 'driver'
    },
    { key: 'contactNumber', header: 'Phone', render: (row) => row.contactNumber || '—' },
    { key: 'manifest', header: 'Scheduled Trips', value: true, render: (row) => (row.manifest ? row.manifest.length : '—') }
  ];

  ngOnChanges() {
    if (!this.data) return;

    const summary = this.data.summary || {};
    const timelines = this.data.timelines || [];
    const driversManifestWithoutTimeline = this.data.driversManifestWithoutTimeline || [];
    const isRange = summary.digestScope === 'date-range';

    this.statusSegments = driverDigestSegments(summary);
    this.digestStatItems = driverDigestStatItems(summary, isRange);

    const palette = [CHART_COLORS[1], CHART_COLORS[3], CHART_COLORS[2], CHART_COLORS[4], CHART_COLORS[0]];
    this.timelineStatusItems = aggregateTimelineStatus(timelines).map((item, index) => ({
      ...item,
      color: palette[index % 5]
    }));

    this.hoursByDriver = topDriversByHours(timelines);
    this.noTimesheetItems = driversManifestWithoutTimeline.map((driver: any) => ({
      label: driverDisplayName(driver),
      value: driver.manifest ? driver.manifest.length : 0
    }));

    this.timelines = timelines;
    this.driversWithoutTimeline = driversManifestWithoutTimeline;

    this.timelineColumns = [
      {
        key: 'driver',
        header: 'Driver',
        type: 'avatar',
        avatarName: (row) => driverDisplayName(row.driver),
        avatarImage: (row) => driverProfileImage(row),
        avatarVariant: 'driver'
      },
      { key: 'status', header: 'Status', type: 'badge', badgeClass: (row) => timelineStatusBadge(row.status), badgeLabel: (row) => timelineStatusLabel(row.status) },
      { key: 'checkin', header: 'Check-In', render: (row) => formatDateTime(row.checkin) },
      { key: 'hours', header: 'Hours', value: true, render: (row) => formatHours(row.todayHours != null ? row.todayHours : millisToHours(row.workTimeInMillis)) },
      ...(isRange ? [] : [{ key: 'weekHours', header: 'Week Hours', value: true, render: (row: any) => formatHours(millisToHours(row.totalWeekHours)) }])
    ];
  }
}
